import React, {ReactElement} from "react";
import classes from './Notification.module.scss'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTimes} from "@fortawesome/pro-regular-svg-icons";
import {animated, useTransition} from "react-spring";

interface Props {
	label?: string,
	open: boolean,
	onClick?: () => void
}

const Notification = (props: Props): ReactElement<Props> => {

	const transition = useTransition(props.open, null, {
		from: {
			opacity: 0,
			transform: 'translateX(-20vw)'
		},
		enter: {
			opacity: 1,
			transform: 'translateX(0)'
		},
		leave: {
			opacity: 0,
			transform: 'translateX(-20vw)'
		},
		config: {
			friction: 15,
			tension: 450,
			clamp: true
		}
	});

	return (
		<>
			{transition.map(item => item.item && (
				<animated.div
					key={item.key}
					style={item.props}
					className={classes.root}
				>
					<p>{props.label}</p>
					<FontAwesomeIcon
						onClick={props.onClick}
						className={classes.icon}
						icon={faTimes}
					/>
				</animated.div>
			))}
		</>
	)
}

export default Notification